import { createGlobalStyle } from "styled-components";

export const GettingStartedStyles = createGlobalStyle`
  [data-test-id='home-getting-started'] {
    align-self: start;
    width: 100%;
    max-width: 535px;
  }

  [data-test-id='home-getting-started'] > div:first-child > h2 {
    color: ${({theme}) => theme.palette[850]};
  }

  [data-test-id='home-getting-started'] > div:first-child {
    align-items: center;
  }

  [data-test-id='home-getting-started'] > div:first-child > p {
    color: ${({theme}) => theme.icon.primary};
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div {
    box-sizing: border-box;
    width: 100%;
    padding: 14px 20px;
    overflow: hidden;
    border-radius: 14px;
    background: ${({theme}) => theme.isDark ? theme.palette[100] : theme.base.white};
    box-shadow: ${({theme}) => theme.isDark
      ? '0 4px 30px rgba(0, 0, 0, 0.25)'
      : '0 4px 30px rgba(186, 196, 211, 0.2)'};
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div:first-child {
    height: 72px;
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(2),
  [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(3) {
    height: 92px;
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div > div:first-child {
    width: 437px;
    max-width: 100%;
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div > div:first-child > p:first-child {
    color: ${({theme}) => theme.icon.primary};
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div > div:first-child > p:last-child {
    width: 380px;
    max-width: 100%;
    color: ${({theme}) => theme.palette[650]};
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div:first-child > img {
    top: 2px;
    right: 28px;
    bottom: auto;
    width: 100px;
    height: 70px;
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(2) > img {
    top: 15px;
    right: 34px;
    bottom: auto;
    width: 88px;
    height: 77px;
  }

  [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(3) > img {
    top: 0;
    right: 25px;
    bottom: auto;
    width: 108px;
    height: 92px;
  }

  @media screen and (max-width: 600px) {
    [data-test-id='home-getting-started'] > div:first-child {
      gap: 12px;
    }

    [data-test-id='home-getting-started'] > div:nth-child(2) > div,
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:first-child,
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(2),
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(3) {
      height: auto;
      min-height: 92px;
    }

    [data-test-id='home-getting-started'] > div:nth-child(2) > div > div:first-child {
      width: calc(100% - 88px);
      min-width: 0;
    }

    [data-test-id='home-getting-started'] > div:nth-child(2) > div > div:first-child > p {
      overflow-wrap: anywhere;
    }

    [data-test-id='home-getting-started'] > div:nth-child(2) > div > img,
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:first-child > img,
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(2) > img,
    [data-test-id='home-getting-started'] > div:nth-child(2) > div:nth-child(3) > img {
      top: 50%;
      right: 12px;
      bottom: auto;
      width: auto;
      height: auto;
      max-width: 80px;
      max-height: 72px;
      transform: translateY(-50%);
    }
  }
`
